<template>
  <BaseCottageListPage
    v-if="!pending && cottagesData?.cottages && cottagesMeta?.pagination"
    :cottages-data="cottagesData"
    :cottages-meta="cottagesMeta"
    :location-name="locationName"
  >
  </BaseCottageListPage>
</template>

<script setup lang="ts">
import { useMenuBreadcrumbStore } from '~~/modules/menu/stores/useMenuBreadcrumbStore'
import { useHeadInfoComposable } from '~~/modules/head/composables/useHeadInfoComposable'
import { useCottageListPage } from '~~/modules/views/cottage-list/composables/useCottageListPage'
import { useSendCottageStats } from '~~/modules/views/cottage-list/composables/useSendCottageStats'

const { setHeadInfo } = useHeadInfoComposable()
const breadCrumbMenuStore = useMenuBreadcrumbStore()
let locationName: string

const {
  pending,
  cottagesData,
  cottagesMeta,
  error,
  getCurrentLocationName,
  initializePage,
  getBreadcrumbData,
  getHeadInfoData,
  showErrorPage,
} = useCottageListPage({})

await initializePage()

if (import.meta.client) {
  const { sendCottageStats, sendCottageStatsCloudwatch } = useSendCottageStats()
  sendCottageStats(cottagesData.value)
  sendCottageStatsCloudwatch(cottagesData.value)
}

if (error.value) {
  showErrorPage(error.value)
} else {
  locationName = getCurrentLocationName()
  const breadcrumbData = getBreadcrumbData()
  if (breadcrumbData) {
    breadCrumbMenuStore.setMenuBreadcrumb(
      breadcrumbData.name,
      breadcrumbData.middleItems,
    )
  }

  setHeadInfo(getHeadInfoData())
}
</script>
